<template>
    <b-card v-if="data" class="chart-funds mb-0" body-class="pb-0 pt-0">
      <vue-apex-charts
        height="160"
        :options="statisticsOrder.chartOptions"
        :series="data.series"
      />
    </b-card>
  </template>
  
  <script>
  import { BCard } from "bootstrap-vue";
  import VueApexCharts from "vue-apexcharts";
  
  const $barColor = "#f3f3f3";
  
  export default {
    name: "PaymentsChart",
    components: {
      BCard,
      VueApexCharts,
    },
    props: {
      data: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        statisticsOrder: {
          chartOptions: {
            chart: {
              type: "bar",
              stacked: true,
              toolbar: {
                show: false,
              },
            },
            grid: {
              show: true,
              borderColor: "#111",
              strokeDashArray: 7,
              // padding: {
              //   left: 0,
              //   right: 0,
              //   top: -15,
              //   bottom: -15,
              // },
              xaxis: {
                lines: {
                  show: false,
                },
              },
              yaxis: {
                lines: {
                  show: true,
                },
              },
            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: "70%",
                // startingShape: 'rounded',
                colors: {
                  backgroundBarColors: ["#fff", "#fff", "#fff", "#fff", "#fff"],
                  backgroundBarRadius: 5,
                },
              },
            },
            legend: {
              show: false,
            },
            dataLabels: {
              enabled: false,
            },
            colors: ["#15CE75"],
  
            xaxis: {
              labels: {
                show: true,
              },
              axisBorder: {
                show: true,
              },
              axisTicks: {
                show: true,
              },
              categories: this.data.labels,
            },
            yaxis: {
              // min: this.data.minY,
              // max: this.data.maxY,
              show: true,
              tickAmount: 1,
              labels: {
                formatter: function (value) {
                  return 'S/' + value;
                },
              },
            },
            tooltip: {
              x: {
                show: true,
              },
            },
          },
        },
      };
    },
  };
  </script>
  